import React from 'react';
import PropTypes from 'prop-types';

const MobileTopNavWithButtonsSmallView = ({
  onClick,
  headerText,
  buttonsTexts,
  onButtonsClick,
  selectedIndex,
}) => (
  <div className="mobile-top-nav-with-buttons">
    <button className="mobile-top-nav-small-back" type="button" onClick={onClick}>
      <i className="mobile-top-nav-small-back-i fa fa-caret-left" />
      {headerText}
    </button>
    <div className="mobile-top-nav-with-buttons-wrapper">
      <button
        className={`mobile-top-nav-with-button-btn${selectedIndex === 0 ? ' selected' : ''}`}
        type="button"
        onClick={onButtonsClick[0]}
      >
        {buttonsTexts[0]}
      </button>
      <button
        className={`mobile-top-nav-with-button-btn${selectedIndex === 1 ? ' selected' : ''}`}
        type="button"
        onClick={onButtonsClick[1]}
      >
        {buttonsTexts[1]}
      </button>
    </div>
  </div>
);

MobileTopNavWithButtonsSmallView.propTypes = {
  buttonsTexts: PropTypes.arrayOf(PropTypes.string).isRequired,
  onButtonsClick: PropTypes.arrayOf(PropTypes.func).isRequired,
  onClick: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
  selectedIndex: PropTypes.number.isRequired,
};

export default MobileTopNavWithButtonsSmallView;
